export default "__VITE_ASSET__Djzkqwmd__"